export default {
  skillItems: [],
  skillItem: undefined,
};
